import * as React from 'react'
import styled from 'styled-components'
import Link from 'theme/atoms/Link'
import theme from 'theme'
import LinkArrow from 'assets/link-arrow.svg'
import * as evt from './events'
import useInView from 'hooks/useInView'
import { OptImg } from 'utils/imageOptimization'
import useLazyImgSrc from 'hooks/useLazyImgSrc'

type Props = {
  campaignID?: string
  campaignName?: string
  campaignCreative?: string
  title: string
  imgUrl: OptImg
  linkTarget: string
  linkLabel: string
  template: 'Image'
  gridArea: string
  teaserNumber: 1 | 2
  listname: string
}

// proportion: 2000:1300
export default function Intersticial(props: Props) {
  const [imgRef, imgSrc] = useLazyImgSrc<HTMLImageElement>(props.imgUrl, 100)
  const [ref, isInView] = useInView(-200, true)

  let { campaignID, campaignName, campaignCreative, gridArea } = props

  campaignID = campaignID ? campaignID : props.gridArea
  campaignName = campaignName ? campaignName : `Teaser ${props.teaserNumber}`
  campaignCreative = campaignCreative ? campaignCreative : ''
  gridArea = `${props.listname} | ${gridArea}`
  const trackingProps = {
    campaignID,
    campaignName,
    campaignCreative,
    gridArea
  }

  React.useEffect(() => {
    if (!isInView) return
    evt.scrollIntoView(trackingProps)
  }, [isInView])
  return (
    <Wrapper
      className="Intersticial"
      to={props.linkTarget}
      ref={ref}
      onClick={() => evt.widgetClick(trackingProps)}
      data-cy-handle="Intersticial"
    >
      <picture>
        <img ref={imgRef} src={imgSrc} />
      </picture>

      <div className="title-wrapper">
        <div className="title">{props.title}</div>
        <span>
          {props.linkLabel} <LinkArrow />
        </span>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled(Link)`
  position: relative;

  > picture {
    width: 100%;
    height: 100%;
    > img {
      display: inline-block;
      max-width: 100%;
    }
  }

  .title-wrapper {
    position: absolute;
    background: white;
    bottom: ${theme.spacing('m')};
    left: 0;
    min-width: 30%;
    max-width: 95%;
    padding: ${theme.spacing('m')};

    > .title {
      margin-bottom: ${theme.spacing('xxs')};
      ${theme.ty('rc-base')};
      @media (min-width: ${theme.ms.SM}px) {
        margin-bottom: ${theme.spacing('xs')};
        ${theme.ty('rc-2xl')};
      }
    }

    > span {
      ${theme.ty('r-s', 'bold')}
      color:${theme.colors.primary};
      @media (min-width: ${theme.ms.SM}px) {
        display: block;
        ${theme.ty('rc-base', 'bold')}
      }
      > svg {
        margin-bottom: -3px;
        margin-left: 3px;

        color: ${theme.colors.primary};
        #Path-5,
        #Path-6 {
          color: ${theme.colors.primary};
          stroke: ${theme.colors.primary};
        }
        g {
          color: ${theme.colors.primary};
          stroke: ${theme.colors.primary};
          filter: none;
        }
      }
    }
  }
`
